module.exports = __webpack_public_path__ + "img/2025-10-15b_1.f671c657.jpg";